/* eslint-disable @typescript-eslint/no-explicit-any */
import type { RemixiconComponentType } from "@remixicon/react";
import {
  RiHomeLine,
  RiFileChartLine,
  RiPresentationLine,
  RiEditLine,
  RiNumbersLine,
  RiCalendarLine,
  RiAdminFill,
  RiSearchEyeFill,
  RiComputerLine,
  RiUserSettingsLine,
  RiListSettingsLine,
  RiTeamLine,
  RiShieldKeyholeLine,
  RiCalendarTodoLine,
  RiCustomerService2Line,
  RiDashboardFill,
  RiMegaphoneLine,
  RiRfidFill,
  RiCustomerServiceLine,
  RiServiceLine,
  RiArticleLine,
} from "@remixicon/react";
import { useAuthStore } from "@/stores/authStore";

export interface MenuItem {
  id: string;
  label: string;
  icon?: RemixiconComponentType;
  href: string | null;
  id_documentacion: number | null;
  children?: MenuItem[];
  requiredPermission?: string | string[];
  showInProduction?: boolean;
}

// Mapeo de los nombres esperados (menu.icon) a componentes Remix Icon
const iconMap: Record<string, RemixiconComponentType> = {
  RiHomeLine,
  RiFileChartLine,
  RiPresentationLine,
  RiEditLine,
  RiNumbersLine,
  RiCalendarLine,
  RiAdminFill,
  RiSearchEyeFill,
  RiComputerLine,
  RiUserSettingsLine,
  RiListSettingsLine,
  RiTeamLine,
  RiShieldKeyholeLine,
  RiCalendarTodoLine,
  RiCustomerService2Line,
  RiDashboardFill,
  RiMegaphoneLine,
  RiRfidFill,
  RiCustomerServiceLine,
  RiServiceLine,
  RiArticleLine,
};

const addTokenToHref = (href: string, token: string | undefined): string => {
  if (!token) return href;
  const url = new URL(href);
  const tokenRecortado = token.slice(0, 10) + token.slice(-10);
  url.searchParams.set("tkn", tokenRecortado);
  return url.toString();
};

const mapMenuItem = (menu: any, token?: string | null): MenuItem => {
  let href = menu.href || null;
  if (href && (href.startsWith("http://") || href.startsWith("https://"))) {
    href = addTokenToHref(href, token ?? "falso");
  }
  return {
    id: menu.id_menu,
    label: menu.etiqueta,
    href,
    id_documentacion: menu.id_documentacion,
    icon: iconMap[menu.icon] || undefined,
    requiredPermission: menu.required_permissions,
    showInProduction: menu.mostrar_en_produccion,
    children: menu.children?.map((child: any) => mapMenuItem(child, token)),
  };
};


// export const blogMenu: MenuItem = {
//   id: 'blog',
//   label: 'Blog',
//   icon: RiArticleLine,
//   href: null,
//   id_documentacion: null,
//   requiredPermission: ['blog_admin'],
//   children: [
//     {
//       id: 'blog-posts',
//       label: 'Posts',
//       href: '/blog',
//       id_documentacion: null,
//       requiredPermission: 'blog_admin',
//     },
//     {
//       id: 'blog-categories',
//       label: 'Categorías',
//       href: '/blog/categories',
//       id_documentacion: null,
//       requiredPermission: 'blog_admin',
//     },
//   ],
// };

export const getMenus = (): MenuItem[] => {
  const { user, token } = useAuthStore.getState();
  if (!user || !user.menus) return [];

  const menus = user.menus.map((menu: any) => mapMenuItem(menu, token));

  // if (hasPermission('blog_admin')) {
  //   menus.push(blogMenu);
  // }

  return menus;
};
